














import { Component, Prop, Vue } from 'vue-property-decorator';
import { Select } from '@/pages/profile/blocks/form';
import { Option, Options } from './types';
import { Events } from './enums';
import { NAME_DEFAULT } from './const';

@Component({
  components: {
    Select,
  },
})
export default class SelectCount extends Vue {
  @Prop({ type: String, default: NAME_DEFAULT })
  name: string;

  @Prop({ type: Array, required: true })
  options: Options;

  @Prop({ type: String, default: '' })
  text: string;

  @Prop({ type: [String, Number], required: true })
  value: Option;

  @Prop({ type: Boolean, default: false })
  bottom: boolean;

  get hasText() {
    return this.text.length > 0;
  }

  get placeholder() {
    return String(this.value);
  }

  onInput(value: Option) {
    this.$emit(Events.CHANGE, value);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/selectcount/SelectCount.vue